<template>
    <div></div>
</template>

<script>
  export default {
    name: 'styleLoader'
  }
</script>

<style lang="scss">
  @import "../../assets/main.scss";
</style>



// WEBPACK FOOTER //
// src/vue/components/StyleLoader.vue